import React from 'react';
import { Bundle } from '@ali/visualengine';
import style from '@ali/vu-style-property';
import { componentName } from "../../const";
import { getContextSetter, getDepsSetter, getDestroyWhenDepsChangeSetter, getJsonPropsSetter, getPage } from "../../utils";
import { PageSelectSetter } from "./pageSelectSetter";
import Icon from "./logo";
var ActionSetter = window.VisualEngineUtils.ActionSetter;

// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype
export default Bundle.createPrototype({
  enableCopy: true,
  title: '嵌入搭建页面片段',
  componentName: componentName,
  category: '高级',
  icon: Icon,
  screenshot: '',
  docUrl: '',
  configure: [getContextSetter(), {
    name: 'pageSelect',
    title: '选择搭建页面',
    display: 'block',
    setter: /*#__PURE__*/React.createElement(PageSelectSetter, null),
    initialValue: function initialValue(v) {
      var page = getPage();
      return v || {
        app: {
          appCode: page.appCode
        }
      };
    }
  }, getJsonPropsSetter(), getDepsSetter(), getDestroyWhenDepsChangeSetter(), {
    name: 'onSaveThis',
    title: '保存子页面的this',
    setter: /*#__PURE__*/React.createElement(ActionSetter, {
      defaultCode: "function onSaveThisForLowcodePage(_this) {\n  // \u8BF7\u4FEE\u6539\u6B64\u53D8\u91CF\u540D\u5B57\n  this._thisForLowcodePage = _this\n}",
      defaultActionName: "onSaveThisForLowcodePage"
    })
  }, style({
    advanced: true
  })]
});